const displayEndDate = (endDate: string | null) => {
  if (endDate === '-') {
    return 'Ongoing';
  }
  return endDate;
};

export default displayEndDate;
